import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["atc"];
  //static values = { id: Number }

  initialize() {}

  test() {
    console.log("Cart test");
  }

  test_bis() {
    console.log("Test bis");
    var id = parseInt(this.atcTarget.getAttribute("data-pizza-id"));
    var size = this.atcTarget.getAttribute("data-pizza-size");
    console.log(this.atcTarget);
    console.log("Stuff", id, size);
  }

  add(e) {
    // console.log(e.target);
    var size = e.currentTarget.dataset.pizzaSize;
    var id = e.currentTarget.dataset.pizzaId;
    console.log("Adding PIZZA ID : " + id + " Size : " + size);
    var data = { type: "pizza", id: id, size: size };
    var form_data = new FormData();
    for (var key in data) {
      form_data.append(key, data[key]);
    }
    Rails.ajax({
      type: "post",
      url: "/home/add_pizza_to_cart",
      data: form_data,
    });
  }

  get cartController() {}
}
